exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider[data-v-fe29a760] {\n  position: relative;\n  width: 100%;\n}\n.slider[data-v-fe29a760] .el-slider {\n  position: absolute;\n  top: -5px;\n  width: 167px;\n}\n.slider[data-v-fe29a760] .el-slider .el-slider__button {\n  width: 12px;\n  height: 12px;\n}\n.slider .slider-input[data-v-fe29a760] {\n  position: absolute;\n  display: inline-block;\n  margin-left: 17px;\n  width: 64px;\n  right: 0;\n  top: 0;\n}\n", ""]);

// exports
